<template>
  <div v-if="isInRole(['admin', 'support','analyst'])">
    <toolbar />
    <zlick-navigation />

    <v-container fluid text-xs-center>
      <v-dialog v-model="dialog" max-width="500px">
        <v-card>
          <v-card-text>
            <v-flex xs12 offset-xs0>
              <h3>{{this.$t("cancelOrderDialog")}}</h3>
            </v-flex>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" flat @click.native="close">{{this.$t("cancel")}}</v-btn>
            <v-btn color="blue darken-1" flat @click.native="updateState">{{this.$t("unsubscribe")}}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-container>

    <v-container v-if="!error" fluid text-xs-center>
    <v-layout row wrap center>
      <v-flex xs12 offset-xs0>
        <v-data-table
          :headers="headers"
          :items="items"
          :pagination.sync="pagination"
          :total-items="getTotalItems"
          item-key="_id"
          hide-actions
          class="elevation-1">
          <template slot="items" slot-scope="props">
            <tr>
            <td>{{ formatDate(props.item.createdAt) }}</td>
            <td>
              {{ ((props.item.paymentType!=="external_payment" && props.item.paymentType!=="unpaid" ) && props.item.subscriptionExpiresAt) ? formatDate(props.item.subscriptionExpiresAt) : ''}}
                <v-menu
                  v-model="form[`${props.item._id}`]"
                  ref="menu"
                  :close-on-content-click="false"
                  :return-value.sync="date"
                  transition="scale-transition"
                  offset-y
                  max-width="290px"
                  min-width="290px"
                  v-if="props.item.subscriptionExpiresAt && (props.item.paymentType==='external_payment' || props.item.paymentType==='unpaid')"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-layout row wrap>
                      <v-flex>
                        {{ formatDate(props.item.subscriptionExpiresAt) }}
                      </v-flex>
                      <v-flex>
                        <v-icon v-bind:style="{ marginBottom: '3px' }" @click="date = formatDate(props.item.subscriptionExpiresAt, 'YYYY-MM-DD')" v-model="date" v-bind="attrs" v-on="on" :size="'small'" readonly>create</v-icon>
                      </v-flex>
                    </v-layout>
                  </template>
                  <v-date-picker
                    v-model="date"
                    :show-current="formatDate(props.item.subscriptionExpiresAt, 'YYYY-MM-DD')"
                    no-title
                    scrollable
                  >
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="form[`${props.item._id}`] = false">{{$t("cancel")}}</v-btn>
                    <v-btn text color="primary" @click="updateExpiryDate(date, props.item._id)">{{$t("ok")}}</v-btn>
                  </v-date-picker>
                </v-menu>

            </td>
            <td>{{ (props.item.productData && props.item.productData.name) || '-'}}</td>
            <td class="text-xs-center"><a @click="props.expanded = !props.expanded">{{ props.item.phone }}</a></td>
            <td class="text-xs-center">{{ props.item.email }}</td>
            <td class="text-xs-center">{{ (props.item.productData.pricing[0].price / 100).toLocaleString().replace('.', ',') }}</td>
            <td class="text-xs-center">{{ props.item.paymentType }}</td>
            <td class="text-xs-center">{{ props.item.clientUserId }}</td>
            <td class="text-xs-center" v-if="props.item.productData && props.item.productData.type==='subscription' && props.item.state !=='active'">
              {{ props.item.state }}
            </td>
            <td class="text-xs-center" v-if="props.item.productData && props.item.productData.type==='subscription' && props.item.state ==='active'">
              <v-btn icon class="mx-0" v-if="!isAnalyst()" @click="showCancelBox(props.item)">
                <v-icon color="pink">cancel</v-icon>
              </v-btn>
            </td>
            <td v-if="props.item.productData && props.item.productData.type!=='subscription'">
              {{$t('oneOffPayment')}}
            </td>
            <td v-if="!props.item.productData">
              {{$t('noStatus')}}
            </td>
            </tr>
          </template>
          <template slot="expand" slot-scope="props">
            <v-card dark>
              <v-card-title>{{$t('transactionsHistory')}}</v-card-title>
              <v-card-text>
                <v-data-table dark :items="props.item.transactions" hide-actions :headers="transactionHeaders">
                   <template slot="items" slot-scope="transactions">
                     <td>{{formatDate(transactions.item.createdAt)}}</td>
                     <td>{{transactions.item.type}}</td>
                     <td>{{transactions.item.amount}}</td>
                     <td>{{transactions.item.carrierTransactionId}}</td>
                   </template>
                </v-data-table>
              </v-card-text>
            </v-card>
          </template>
          <template slot="no-data">
            <v-btn color="primary" @click="initialize">{{this.$t('reset')}}</v-btn>
          </template>
        </v-data-table>
      </v-flex>
      </v-layout>
    </v-container>
    <v-container v-if="!error" fluid text-xs-center>
      <v-pagination
        v-model="pagination.page"
        :length="pagesCount"
        @input="newPage(pagination.page)"
      />
    </v-container>
    <v-container v-if="error" grid-list-md>
      <v-layout row justify-center>
        <v-flex xs12 offset-xs4>
          <v-text-field color="error" v-text="error"/>
        </v-flex>
      </v-layout>
    </v-container>
    <v-snackbar
      :timeout="snackbar.timeout"
      :color="snackbar.color"
      v-model="snackbar.show"
    >
      {{ snackbar.text }}
    </v-snackbar>
  </div>
</template>

<script>

import Toolbar from './Toolbar'
import ZlickNavigation from './ZlickNavigation'
import SubscriptionsService from '../services/SubscriptionsService'
import moment from 'moment'
// import ZlickApiService from '../services/ZlickApiService'
import AuthenticationService from '../services/AuthenticationService'
import Raygun from '../services/Raygun'
import { mapState } from 'vuex'

export default {
  components: {
    Toolbar,
    ZlickNavigation
  },
  data: function () {
    return {
      form: {
      },
      date: new Date().toISOString().substr(0, 10),
      dialog: false,
      itemToCancel: '',
      headers: [
        {text: this.$t('createdAt'), value: 'createdAt', align: 'center'},
        {text: this.$t('expiryDate'), value: 'subscriptionExpiresAt', align: 'center'},
        {text: this.$t('productName'), value: 'productName', align: 'center'},
        {text: this.$t('phone'), value: 'phone', align: 'center'},
        {text: this.$t('email'), value: 'email', align: 'center'},
        {text: this.$t('amount'), value: 'amount', align: 'center'},
        {text: this.$t('paymentType'), value: 'paymentType', align: 'center'},
        {text: this.$t('clientUserId'), value: 'clientUserId', align: 'center'}
        // {text: this.$t('carrier'), value: 'carrier', align: 'center'}
      ],
      transactionHeaders: [
        {text: this.$t('createdAt'), value: 'createdAt', align: 'center'},
        {text: this.$t('transactionType'), value: 'type', align: 'center'},
        {text: this.$t('amount'), value: 'amount', align: 'center'},
        {text: this.$t('transaction_id'), value: 'carrierTransactionId', align: 'center'}
      ],
      snackbar: {
        timeout: 4000,
        color: 'success',
        mode: 'vertical',
        show: false
      },
      error: null,
      states: ['active', 'inactive', 'past_due', 'canceled']
    }
  },
  beforeCreate () {
    if (!AuthenticationService.isUserLoggedIn()) {
      this.$router.push('/login')
    }
  },
  created () {
    this.initialize()
    if (!this.isAnalyst()) {
      this.headers.push({text: this.$t('name'), value: 'name', sortable: false, align: 'center'})
    }
  },
  watch: {

    activeCognitoGroup (newValue, oldValue) {
      console.log(`cognito Updating from ${oldValue} to ${newValue}`)
      this.initialize()
    },

    pagination: {
      handler () {
        this.$store.dispatch('sortSubscriptions')
      },
      deep: true
    }
  },

  computed: {

    ...mapState({
      activeCognitoGroup: state => state.user.activeCognitoGroup
    }),

    pagination: {
      get: function () {
        return this.$store.state.pagination
      },
      set: function (newValue) {
        this.$store.commit('setPagination', newValue)
      }
    },
    items: {
      get: function () {
        return this.$store.state.subscriptions.docs
      },
      set: function (newValue) {
        this.$store.commit('setSubscriptions', newValue)
      }
    },
    getTotalItems () {
      return this.$store.state.subscriptions.total
    },
    pagesCount () {
      let totalItems = this.$store.state.subscriptions.total
      if (!totalItems || totalItems === 0) return 0
      return Math.ceil(totalItems / this.pagination.rowsPerPage)
    }
  },
  methods: {
    isAnalyst () {
      return AuthenticationService.isAnalyst()
    },
    isInRole (roles) {
      return AuthenticationService.isInRole(roles)
    },
    async newPage (page) {
      let searchValue = this.$store.state.searchValue
      let dateRange = this.$store.state.dateRange

      if (!searchValue && this.objectIsEmpty(dateRange)) {
        this.initialize(page)
      } else {
        let searchQuery = {
          searchValue,
          dates: {
            startDate: dateRange.startDate,
            endDate: dateRange.endDate
          }
        }
        let response = await SubscriptionsService.search({searchQuery, page, limit: this.pagination.rowsPerPage})
        this.$store.commit('setSubscriptions', response.data)
      }
    },
    objectIsEmpty (object) {
      return Object.keys(object).length === 0 && object.constructor === Object
    },
    showCancelBox (item) {
      this.dialog = true
      this.itemToCancel = item
    },
    async updateExpiryDate (date, id) {
      try {
        await SubscriptionsService.update({subscriptionId: id, subscriptionExpiresAt: date})
        await this.initialize()
        this.snackbar.show = true
        this.snackbar.color = 'success'
        this.snackbar.text = 'Subscription\'s expiry date updated'
      } catch (error) {
        Raygun.send(error)
        this.snackbar.show = true
        this.snackbar.color = 'error'
        this.snackbar.text = 'Failed to update subscription\'s expiry date'
      } finally {
        this.form[id] = false
      }
    },

    close () {
      this.dialog = false
    },

    async initialize (page = 1, limit = 20) {
      try {
        this.error = null
        let response = await SubscriptionsService.search({page, limit})
        this.$store.commit('setSubscriptions', response.data)
      } catch (error) {
        this.error = error.message
        Raygun.send(error)
      }
    },

    formatDate (date, format = 'DD.MM.YYYY HH:mm:ss') {
      return moment(date).format(format)
    },

    async updateState () {
      try {
        await SubscriptionsService.update({state: 'canceled', subscriptionId: this.itemToCancel._id})
        await this.initialize()
        this.snackbar.show = true
        this.snackbar.color = 'success'
        this.snackbar.text = 'Subscription\'s state updated'
      } catch (error) {
        Raygun.send(error)
        this.snackbar.show = true
        this.snackbar.color = 'error'
        this.snackbar.text = 'Failed to update subscription\'s state'
      } finally {
        this.close()
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Subscriptions.vue